import { PlusOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import React, { useState } from 'react';

import { SearchBar } from '../../../components/SearchBar';
import { AddOrEditModal } from './AddOrEditModal';

type HeaderProps = {
  searchValue: string;
  onSearch: (value: string) => void;
  onAdd: () => void;
};

export const Header = ({ searchValue, onSearch, onAdd }: HeaderProps): JSX.Element => {
  const [modalVisible, setModalVisible] = useState(false);

  const handleModalOpen = () => setModalVisible(true);
  const handleModalClose = () => setModalVisible(false);

  return (
    <>
      <h1>Users</h1>

      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:gap-8">
        <div className="w-full sm:w-1/4">
          <SearchBar value={searchValue} onChange={onSearch} />
        </div>

        <Button
          type="primary"
          size="large"
          block
          onClick={handleModalOpen}
          className="!h-12 !text-base sm:!h-9 sm:!text-sm sm:!w-auto"
        >
          <PlusOutlined />
          Add User
        </Button>
      </div>

      <AddOrEditModal
        modalVisible={modalVisible}
        onCancel={handleModalClose}
        onSuccess={() => {
          handleModalClose();
          onAdd();
        }}
      />
    </>
  );
};
